<template>
  <div class="grid-head">
    <div class="topnav">
      <a class="nav-link active" :href="`${basePath}play/${accountName}?${activeLinkParams}`">
        <i class="exicon-bar-chart"></i>
        Polls
      </a>
      <a class="go-to-audienceQa nav-link" :href="audienceQaLink">
        <i class="exicon-qa-alt"></i>
        Q & A
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'NavHeader',
  props: {
  },
  computed: {
    ...mapGetters('poll', [
      'accountName'
    ]),
    ...mapState('poll', [
      'activeLinkParams',
      'basePath'
    ]),
    audienceQaLink() {
      return `${process.env.VUE_APP_API_URL}/s/play/${this.accountName}/audienceQA?${this.activeLinkParams}`;
    }
  }
}
</script>

<style scoped lang="scss">
  @font-face {
    font-family: 'excitemuicon';
    src: url("./../assets/webfonts/excitemuicon.woff?hq5") format("truetype"), url("./../assets/webfonts/excitemuicon.woff?hq5") format("woff"), url("./../assets/webfonts/excitemuicon.svg?hq5#excitemuicon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  [class^="exicon-"], [class*=" exicon-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'excitemuicon' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .exicon-bar-chart:before {
    content: "\e932";
  }

  .exicon-qa-alt:before {
    content: "\e93b";
  }

  .grid-head {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #24262D;
    color: #fff;
    text-align: center;
    height: 60px;
    z-index: 1000;
  }

  .grid-head .topnav {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border-bottom: none;
    margin: 0 auto;
    width: 100%;
  }

  @media only screen and (min-width: 992px) {
    .grid-head .topnav {
      width: auto;
      display: -webkit-inline-box;
      display: -ms-inline-flexbox;
      display: inline-flex;
    }
  }

  .grid-head .topnav > a {
    text-align: center;
    border-radius: 0;
    padding: 10px 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    text-decoration: none;
    width: 100%;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    height: 60px;
    color: #9AA1BA;
    font-weight: 600;
    border-color: transparent !important;
    -webkit-transition: .25s ease-out;
    transition: .25s ease-out;
  }

  @media only screen and (min-width: 992px) {
    .grid-head .topnav > a {
      width: 150px;
    }
  }

  .grid-head .topnav > a i {
    margin-right: 8px;
    font-size: .9em;
  }

  .grid-head .topnav > a:hover {
    color: #acb2c9;
    background-color: rgba(0, 0, 0, 0.1);
  }

  .grid-head .topnav > a.active {
    color: #F6A821;
    -webkit-box-shadow: inset 0 -3px 0 #F6A821;
    box-shadow: inset 0 -3px 0 #F6A821;
    background-color: transparent;
  }

  .grid-head .topnav > a.active:hover {
    background-color: transparent;
  }

  .style-cryms .grid-head .topnav {
    flex-direction: row-reverse;
  }

  .style-cryms {
    font-family: Oswald, Helvetica-Neue, Helvetica, Arial, sans-serif;
  }
  .style-cryms .grid-head {
    background-color: #fff;
    -webkit-box-shadow: 0 1px 0 #dbdee9;
    box-shadow: 0 1px 0 #dbdee9;
  }
  .style-cryms .grid-head .topnav > a:hover {
    background-color: transparent;
    color: rgba(0, 0, 0, 0.75);
  }
  .style-cryms .grid-head .topnav > a.active {
    color: #000;
    -webkit-box-shadow: inset 0 -3px 0 #000;
    box-shadow: inset 0 -3px 0 #000;
  }
  .style-cryms .nav-tabs-simple > li > .nav-link.active {
    color: #000;
  }
  .style-cryms .nav-tabs-simple > li > .nav-link.active::before {
    background-color: #000;
  }
  .style-cryms .answer-copy {
    font-weight: 500;
  }
  .style-cryms .answers-blank .empty {
    background-color: transparent;
  }
  .style-cryms .form-group-q .btn-primary {
    background-color: #E30615 !important;
  }
  .style-cryms .form-group-q .btn-primary:hover {
    background-color: #eb3c47 !important;
  }
</style>
